import React from 'react'
import cx from 'classnames'

import Link from 'components/link'

import styles from './CredibleRating.module.scss'

const CredibleRatingModal = () => {
  return (
    <div className={styles.modalWrapper}>
      <p className="mb-8 bodySmall neutral500">
        The Credible editorial team collected hundreds of data points to objectively determine
        mortgage lender ratings. The ratings that appear on the Credible dashboard range from 1
        (lowest) to 5 (highest). Our scoring formula weighs several categories and criteria such as
        rates and fees, reputation, eligibility, etc., based on what we believe is most important to
        the consumer.
      </p>
      <p className="bodySmall neutral500">
        The Credible marketplace does not include all available lenders or all of the displayed
        lenders’ available services and product offerings. Find the mortgage methodology{' '}
        <Link
          href="https://www.credible.com/mortgage/lender-review-methodology"
          underline="solid"
          blank
          className={styles.link}
        >
          here
        </Link>
        .
      </p>
      <p className={cx(styles.italic, 'mt-24 bodySmall neutral500')}>
        Ratings last updated: 4/1/24
      </p>
    </div>
  )
}

export default CredibleRatingModal
